import {
    Box,
    Grid,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import ButtonContained from "../../Common/ButtonContained";
import CustomDialog from "../../Common/CustomDialog";
import TextLabel from "../../Common/CommonTextLabel";
import CommonFileUpload from "../../Common/CommonFileUpload";
import { showLoader } from "../../../Redux/Slices/loaderSlice";
import { useDispatch } from "react-redux";
import {
    createaboutUs,
    getallaboutUs,
    updateaboutUs,
    uploadImage,
} from "../../../Redux/Actions/action";
import ErrorHandler from "../../../Utils/handler";
import { toast } from "react-toastify";
import { BucketURL } from "../../../ApiSetup/Api";
import Assets from "../../Common/Assets";
import CommonTextField from "../../Common/CommonTextField";

function AboutUs() {
    // ---------- Hook -----------
    const dispatch = useDispatch();

    // --------------- State -------------
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({});
    const [aboutUseList, setAboutUsList] = useState({});
    const [error, setError] = useState({});
    const [isEdit, setIsEdit] = useState(false);

    const handleClear = () => {
        setOpen(false);
        setIsEdit(false);
        setData({});
        setError({});
    };

    const validation = () => {
        let isValid = true;
        let error = {};
        if (!data.description) {
            error.description = "About Us Description is required";
            isValid = false;
        }
        if (!data.aboutUsImage) {
            error.aboutUsImage = "About Us URL is required";
            isValid = false;
        }
        setError(error);
        return isValid;
    };

    // --------------- Api ---------------
    const handleImageUpload = async (e) => {
        const { files, name } = e?.target;

        const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
        const validTypes = [...validImageTypes];

        const fileData = files[0];
        if (!validTypes.includes(fileData.type)) {
            setError((error) => ({
                ...error,
                bannerImageSize:
                    "Invalid file type. Only JPEG, PNG, JPG, MP4, WebM, and OGG are allowed.",
            }));
            return;
        }

        if (fileData.size > 10485760) {
            setError((error) => ({
                ...error,
                bannerImageSize:
                    "File size exceeds the 10 MB limit. Please upload a smaller file.",
            }));
            return;
        }

        const formData = new FormData();
        formData.append("image", files[0]);

        dispatch(showLoader(true));
        try {
            const result = await dispatch(uploadImage(formData));
            const error = ErrorHandler(result);

            if (error) {
                const uploadedFile = result?.payload?.data?.[0]?.image;

                setData((prevState) => ({
                    ...prevState,
                    [name]: uploadedFile,
                    isImage: validImageTypes.includes(fileData.type),
                }));

                setError((error) => ({
                    ...error,
                    bannerImageSize: "",
                    aboutUsImage: "",
                }));
            }
        } catch (err) {
            console.error("File upload failed:", err);
        } finally {
            dispatch(showLoader(false));
        }
    };

    const _createUpdateAboutus = async () => {
        if (validation()) {
            dispatch(showLoader(true));
            try {
                let body = {
                    image: data?.aboutUsImage,
                    description: data?.description,
                    id: data?._id
                };
                const fn = isEdit ? updateaboutUs : createaboutUs;
                const result = await dispatch(fn(body));
                const error = ErrorHandler(result);
                if (error) {
                    toast.success(result?.payload?.message);
                    _getallaboutUs();
                    handleClear();
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            } finally {
                dispatch(showLoader(false));
            }
        }
    };

    const _getallaboutUs = async () => {
        dispatch(showLoader(true));
        try {
            const result = await dispatch(getallaboutUs());
            const error = ErrorHandler(result);
            if (error) {
                setAboutUsList(result?.payload?.data?.response);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    useEffect(() => {
        _getallaboutUs();
    }, []);

    return (
        <>
            <Grid container spacing={1} xs={12}>
                <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: 500 }}>
                            About Us
                        </Typography>
                        <ButtonContained
                            text={
                                aboutUseList?.[0]?.image
                                    ? "Update About Us"
                                    : "Add About Us"
                            }
                            onClick={
                                aboutUseList?.[0]?.image
                                    ? () => {
                                        setOpen(true);
                                        setIsEdit(true);
                                        setData({
                                            ...aboutUseList?.[0],
                                            aboutUsImage:
                                                aboutUseList?.[0]?.image,
                                        });
                                    }
                                    : () => {
                                        setOpen(true);
                                    }
                            }
                        />
                    </Box>
                </Grid>
                <Grid item xs={6} my={"auto"}>
                    <Typography>
                        {aboutUseList?.[0]?.description}
                    </Typography>
                </Grid>
                <Grid item xs={6} my={"auto"}>
                    <img
                        src={
                            BucketURL + aboutUseList?.[0]?.image
                        }
                        width={"100%"}
                    />
                </Grid>
                {open && (
                    <CustomDialog
                        isOpen={open}
                        handleClose={handleClear}
                        title={isEdit ? "Update About Us" : "Add About Us"}
                        padding={"10px"}
                        width={400}
                        action={
                            <>
                                <ButtonContained
                                    text={isEdit ? "Update About Us" : "Add About Us"}
                                    onClick={_createUpdateAboutus}
                                    minWidth={"100%"}
                                    marginTop={"10px"}
                                />
                            </>
                        }
                    >
                        <Grid container spacing={2} xs={12} ml={-1}>
                            <Grid item xs={12}>
                                <CommonTextField
                                    value={data?.description}
                                    width={"100%"}
                                    text="About Us Description"
                                    type="text"
                                    onChange={(e) => setData({ ...data, description: e?.target?.value })}
                                    placeholder="Enter a About Us Description"
                                    name="Description"
                                    valid
                                    multiline
                                    rows={3}
                                />
                                <TextLabel
                                    title={!data?.description ? error?.description : ""}
                                    color="error"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <CommonFileUpload
                                    text={"About Us Image"}
                                    padding={{ xs: "5px 14px", sm: "30px 14px", lg: "35px 7px" }}
                                    accept="image/jpeg, image/png, image/jpg"
                                    labelTitle="image/jpeg, image/png, image/jpg Up to 10MB"
                                    name={"aboutUsImage"}
                                    onChange={(e) => handleImageUpload(e)}
                                    valid
                                />
                                {data?.aboutUsImage && (
                                    <Assets
                                        src={BucketURL + data?.aboutUsImage}
                                        height={"100px"}
                                        width={"100%"}
                                        alt="About Us Image"
                                    />
                                )}
                                <TextLabel
                                    title={!data?.aboutUsImage ? error?.aboutUsImage : ""}
                                    color="error"
                                />
                                <TextLabel
                                    title={data?.bannerImageSize ? "" : error?.bannerImageSize}
                                    color="error"
                                />
                            </Grid>
                        </Grid>
                    </CustomDialog>
                )}
            </Grid>
        </>
    );
}

export default AboutUs;
